import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import {
	PARAM_LABEL_BENEFICIAIRE,
	PARAM_LABEL_INTERVENANT,
	PARAM_LABEL_INTERVENTION
} from 'src/app/core/services/constant/constants.service';
import { CacheService } from 'src/app/core/services/cache/cache.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MissionRequest } from 'src/app/shared/models/mission/mission-request';
import { Employee } from 'src/app/shared/models/employee/employee';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { ToastService } from 'src/app/core/services/toast/toast.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { Profile } from 'src/app/shared/models/security/profile';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-detail-role',
	templateUrl: './detail-role.component.html',
	styleUrls: ['./detail-role.component.scss']
})
export class DetailRoleComponent implements OnInit {
	role: Profile;
	confirmDeleteModalRef: BsModalRef;
	detailFormationModalRef: BsModalRef;
	competences;

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;
	isAreaActive = false;

	labelRoleCapitalized: string;
	labelIntervenantCapitalizedPluralized: string;
	labelIntervenantCapitalized: string;
	labelInterventionPluralizedCapitalized: string;

	isFormReadOnly = true;
	isAddressSelected: { value: boolean } = { value: false };
	isAddressDefault: { value: boolean } = { value: false };

	/**
	 * Index de pagination de la liste des formations d'un role
	 */
	currentPage: number;

	/**
	 * Attribut sur lequel trier
	 */
	sortType = 'date';

	/**
	 * Ordre de tri
	 */
	sortOrder: SortOrder = 'asc';

	pairMissionRqEmployee: {
		missionRequest: MissionRequest;
		employeeName: string;
	}[] = [];

	listEmployee: Employee[] = [];

	MAX_NAME_CHAR = 25;
	NAME_PATTERN =
		"^[0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+( [0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+)*$";
	form = new FormGroup({
		name: new FormControl('', [
			Validators.required
		]),
		description: new FormControl(''),
	});

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked: { value: boolean } = { value: false };

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private modalService: BsModalService,
		private facade: FacadeService,
		private cacheService: CacheService,
		private toastService: ToastService,
		private logger: LogService
	) {}

	ngOnInit(): void {
		this.cacheService.clearCache();
		this.labelRoleCapitalized =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_BENEFICIAIRE
			);
		this.labelIntervenantCapitalizedPluralized =
			this.facade.dataStorageService.getLabelCapitalizedPluralized(
				PARAM_LABEL_INTERVENANT
			);
		this.labelIntervenantCapitalized =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_INTERVENANT
			);
		this.labelInterventionPluralizedCapitalized =
			this.facade.dataStorageService.getLabelCapitalizedPluralized(
				PARAM_LABEL_INTERVENTION
			);

		// this.isSESSAD = this.facade.dataStorageService.isSESSAD();
		// this.isSAAD = this.facade.dataStorageService.isSAAD();
		// this.isSSIAD = this.facade.dataStorageService.isSSIAD();

		/**
		 * Récupère le paramètre de la route
		 */
		const id = +this.route.snapshot.paramMap.get('id');
		/**
		 * Appel le back pour récupérer l'role grâce à son id
		 */
		this.facade.profileService.getRoleById(id).subscribe({
			next: (role: Profile) => {
				this.role = role;
			},
			error: (err: ErrorResponse) => {
				this.facade.toastService.createHttpErrorToast(
					err.error.message ? err.error.message : '',
					err.status
				);
				this.goBack();
			}
		});
	}

	goBack(): void {
		this.router.navigate(['/gestion/roles/list']);
	}

	goEdit(role: Profile): void {
		const link = ['/gestion/roles/edit', role.id];
		this.router.navigate(link);
	}

	delete(role: Profile): void {
		console.log(role.id);
		this.facade.profileService
				.deleteRole(role.id)
				.subscribe({
					complete: () => {
						this.modalService.hide();
						this.goBack();
				},
					error: (err: ErrorResponse) => {
						this.isValidateButtonClicked.value = false;
						this.toastService.createHttpErrorToast(
							err.error.message,
							err.status
				);
			}
		});
		
	}

	openModal(confirmDeleteTemplate: TemplateRef<any>): void {
		this.confirmDeleteModalRef = this.modalService.show(confirmDeleteTemplate);
	}

	editForm(): void {
		this.isFormReadOnly = false;
	}

	stopEditForm(): void {
		this.form.reset();

		this.isAddressSelected.value = false;
		this.isFormReadOnly = true;
		this.isValidateButtonClicked.value = false;
	}

	permissionsAsString() {
		let str = '';
		this.role.permissions?.sort((a, b) => a.libelle.localeCompare(b.libelle))
			.forEach((e) => (str += e.libelle + ', '));
		return str.slice(0, -2);
	}

	onSubmit() {
		if (this.form.valid) {
			this.isValidateButtonClicked.value = true;
			this.facade.profileService
				.updateProfile(this.role)
				.subscribe({
					complete: () => {
						this.isValidateButtonClicked.value = false;
						this.reload();
					},
					error: (err: ErrorResponse) => {
						this.isValidateButtonClicked.value = false;
						this.toastService.createHttpErrorToast(
							err.error.message,
							err.status
						);
					}
				});
		}
	}

	reload() {
		const currentUrl = this.router.url;
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		this.router.onSameUrlNavigation = 'reload';
		this.router.navigate([currentUrl]);
	}
}
